<template>
  <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0V6H0V0H6ZM11 1H29H31V5H29H11H9V1H11ZM11 11H29H31V15H29H11H9V11H11ZM11 21H29H31V25H29H11H9V21H11ZM0 10H6V16H0V10ZM6 20V26H0V20H6Z" fill="currentColor" />
  </svg>
</template>